<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_menu}} &#8250; {{ item.name }}</h1>
        <div v-if="item" class="categoryList">
          <MenuTree
            :locale="locale"
            :isNew="newItem"
            :langs="lang"
            :menuId="id"
            :activeLinkId="linkInfo.id"
            @setMode="onSetMode"
            @updateListData="updateItem"
            @updateTreeData="updateTree"
            @setEditLink="updateLink" />
          <MenuSns v-if="item.snsLink" class="mt30"
            @setMode="onSetMode"
            :sns="item.snsList" />
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <SetMenuUnit
          :locale="locale"
          :mode="settingMode"
          :link="linkInfo"
          :snsList="item.snsList" />
      </div></div>
    </section>
    <div id="setContent">
      <SetMenuItem
        :locale="locale"
        :isNew="newItem"
        :isCopy="isCopy"
        :langs="lang"
        :activeSns="item.snsLink"
        :menuData="item"
        @setSns="onSetSns"
        @save="onSave" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique.js'
import MenuTree from '@/components/Menu/Tree'
import MenuSns from '@/components/Menu/Sns'
import SetMenuUnit from '@/components/Menu/SettingUnit'
import SetMenuItem from '@/components/Menu/SettingItem'

export default {
  name: 'Menu',
  components: {
    MenuTree,
    MenuSns,
    SetMenuUnit,
    SetMenuItem
  },
  props: [
    'locale',
    'id',
    'isIdle',
    'oId', // 복사일 때 origin id 함께 받음
    'template' // boolean, true이면 복사로만 접근 가능함 (원본 수정/삭제 불가)
  ],
  computed: {
    ...mapGetters({
      getSetting: 'setting/getData',
      getItem: 'menu/getItem'
    }),
    lang () {
      return this.getSetting.lang
    },
    isCopy () {
      return typeof (this.oId) !== 'undefined'
    },
    newItem () {
      return typeof (this.id) === 'undefined' && !this.isCopy
    },
    text () {
      return {
        save: this.newItem ? this.locale.save : this.locale.modify
      }
    },
    item: {
      get () {
        return this.newItem ? this.defaultItem : this.getItem
      },
      set (item) {
        this.$store.dispatch('menu/setItem', item)
      }
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.setItem()
    },
    linkInfo: {
      deep: true,
      handler (link) {
        const treeId = link.id
        const findTree = function (tree) {
          tree.forEach(function (x) {
            if (x.data.id === treeId) {
              x.data = link
            } else {
              if (x.children && x.children.length) {
                findTree(x.children)
              } else {
                return false
              }
            }
          })
        }
        findTree(this.item.tree)
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', (e) => {
      if (this.dirtyFlag) {
        e.returnValue = '\\o/'
      }
    })
    this.init()
  },
  mounted () {
    this.setItem()
  },
  beforeRouteLeave (to, from, next) {
    const tryLogout = to.name === 'login'
    if (this.dirtyFlag && !this.isIdle && !tryLogout) {
      if (window.confirm(`${this.locale.confirm_leave}\n${this.locale.warn_leave}`)) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  data () {
    return {
      dirtyFlag: false,
      settingMode: '', // link, sns
      linkInfo: {},
      defaultItem: {
        name: 'New menu',
        tree: [],
        snsLink: false,
        snsList: [
          {
            id: 'facebook',
            label: 'facebook',
            url: '',
            active: false
          },
          {
            id: 'instagram',
            label: 'instagram',
            url: '',
            active: false
          },
          {
            id: 'youtube',
            label: 'youtube',
            url: '',
            active: false
          },
          {
            id: 'twitter',
            label: 'twitter',
            url: '',
            active: false
          },
          {
            id: 'flickr',
            label: 'flickr',
            url: '',
            active: false
          },
          {
            id: 'tripadvisor',
            label: 'tripadvisor',
            url: '',
            active: false
          }
        ]
      }
    }
  },
  methods: {
    init () {
      if (typeof (this.id) === 'undefined') {
        this.item = this.defaultItem
      }
      this.dirtyFlag = false
      this.settingMode = ''
    },
    flagOn () {
      this.dirtyFlag = true
    },
    updateSns (data) {
      const beforeSns = data.snsList.filter(x => x.active).map(x => x.id)
      const currentSns = this.defaultItem.snsList
      const findBeforeData = function (id) {
        return data.snsList.find(x => x.id === id)
      }
      const mergeList = currentSns.map(function (x) {
        return {
          ...x,
          url: findBeforeData(x.id) ? findBeforeData(x.id).url : '',
          active: beforeSns.includes(x.id)
        }
      })
      return mergeList
    },
    setItem () {
      if (!this.newItem) {
        const menuId = this.isCopy ? this.oId : this.id
        const getMenuItem = !!this.template && this.template ? 'menu/getTemplateItem' : 'menu/getMenuItem'
        this.$store.commit('onLoading', true)
        this.$store.dispatch(getMenuItem, menuId).then((res) => {
          res.snsList = this.updateSns(res)
          res.tree = res.tree.map(x => {
            return {
              ...x,
              data: {
                ...x.data,
                icon2: x.data.icon2 || ''
              }
            }
          })
          this.$store.dispatch('menu/setItem', res).then(() => {
            this.item = res
            this.$store.commit('onLoading', false)
          })
        })
      } else {
        this.updateSns(this.item)
        this.$store.dispatch('menu/setItem', this.item)
      }
    },
    onSetSns (use) {
      this.item.snsLink = use
    },
    onSetMode (mode) {
      this.settingMode = mode
    },
    updateItem (listData) {
      this.item.tree = this._.cloneDeep(listData)
    },
    updateTree (tree) {
      this.item.tree = tree
    },
    updateLink (link) {
      this.linkInfo = link
    },
    validateOnSave () {
      if (typeof (this.item.tree) === 'undefined' || this.item.tree.length <= 0) {
        alert(this.locale.validate_menu_save_empty)
        return false
      } else {
        return true
      }
    },
    onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const id = this.newItem || this.isCopy ? UNIQUE.mid() : this.id
        const data = {
          name: this.item.name,
          created: this.newItem ? new Date().toISOString() : this.item.created,
          updated: new Date().toISOString(),
          snsLink: this.item.snsLink,
          snsList: this.item.snsList,
          tree: this.item.tree
        }
        const menuData = {
          id: id,
          data: data
        }
        const menuListData = {
          id: id,
          name: data.name,
          created: data.created,
          updated: data.updated
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('menu/setMenuItem', menuData)
          .then(() => {
          // save menu list
            const setMenuListData = this.newItem || this.isCopy ? 'menu/setMenuListItem' : 'menu/updateMenuListItem'
            this.$store.dispatch(setMenuListData, menuListData).then(() => {
              this.$store.dispatch('menu/setMenuListData')
              alert(this.locale.complete_save)
              this.dirtyFlag = false
              this.$store.commit('onLoading', false)
              this.$router.replace({ name: 'menuItem', params: { id: menuData.id } })
            })
          })
      }
    }
  }
}
</script>
